import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import SelectDropdown from "../shared/SelectDropdown";
import Input from "../shared/Input";
import SettledTable from "./SettledTable";
import { FiFilter } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import SettledHeader from "./SettledHeader";
const SettledList = ({ onToggleFilter }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [permission, setPermission] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [branch, setBranch] = useState([]);
  const [lenderData, setLenderData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [formInquiryData, setFormInquiryData] = useState({
    from_date: "",
    to_date: "",
    PreferBank: "",
  });

  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;
        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);

  const fetchAllData = async () => {
    const lenderData = await fetchData("getallbankDropdown", {}, "GET");

    if (lenderData) {
      const branchData = lenderData.data;
      setLenderData(getValueLabel(branchData, "lender_name", "id") || []);
    }
  };

  const handleSubmit = async (e) => {
    const userId = localStorage.getItem("id");
    e.preventDefault();
    setIsSubmitting(true);
    if (!formInquiryData.from_date && formInquiryData.to_date) {
      topTost({
        title: "Please select From Date before selecting To Date.",
        icon: "error",
      });
    } else if (formInquiryData.from_date && !formInquiryData.to_date) {
      topTost({
        title: "To Date is required when From Date is selected",
        icon: "error",
      });
    } else if (
      formInquiryData.from_date &&
      formInquiryData.to_date &&
      new Date(formInquiryData.from_date) > new Date(formInquiryData.to_date)
    ) {
      topTost({
        title: "From Date should be less than or equal to To Date",
        icon: "error",
      });
    } else {
      try {
        const form = new FormData();
        form.append("from_date", formInquiryData.from_date);
        form.append("to_date", formInquiryData.to_date);

        if (formInquiryData.PreferBank) {
          form.append("PreferBank", formInquiryData.PreferBank);
        }

        form.append("moduleId", M_id);
        form.append("userId", userId);

        const response = await fetchFormData(
          "get-loan-setteled-datefilter",
          form,
          "POST",
          true
        );

        if (response && response.data) {
          setFilterData(response.data);
        } else {
          topTost({
            title: response?.message || "Records not found",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Filter submit error:", error);
        topTost({
          title: "Unexpected error occurred",
          icon: "error",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  const handleChange = (name, value) => {
    setFormInquiryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLenderChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        PreferBank: selected.value,
      }));
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleReset = () => {
    setFormInquiryData({
      from_date: "",
      to_date: "",
      PreferBank: "",
    });
    setFilterData([]);
  };
  const handleClose = () => {
    setShowFilters(!showFilters);
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <SettledHeader
              onToggleFilter={() => setShowFilters(!showFilters)}
              permission={permission}
            />
          </PageHeader>

          {showFilters && (
            <div className="main-content-top">
              <div className="row">
                <div className="col-lg-12 mt-3">
                  <div className="card stretch stretch-full function-table">
                    <div className="card-body p-10">
                      <form onSubmit={handleSubmit}>
                        <div className="row px-3 mt-3 ">
                          <div className="col-lg-6">
                            <Input
                              label="From Date"
                              name="from_date"
                              type="date"
                              value={formInquiryData.from_date}
                              onChange={handleChange}
                              placeholder="From Date"
                              icon="feather-calendar"
                            />
                          </div>
                          <div className="col-lg-6">
                            <Input
                              label="To Date"
                              name="to_date"
                              type="date"
                              value={formInquiryData.to_date}
                              onChange={handleChange}
                              placeholder="To Date"
                              icon="feather-calendar"
                            />
                          </div>
                          <div className="row mb-4">
                            <div className="col-md-2">
                              <label className="fw-semibold py-2">
                                Prefer Lender:
                              </label>
                            </div>
                            <div className="col-lg-4">
                              <SelectDropdown
                                options={lenderData}
                                selectedOption={
                                  lenderData.find(
                                    (opt) =>
                                      opt.value ===
                                      String(formInquiryData.PreferBank)
                                  ) || null
                                }
                                value={formInquiryData.PreferBank}
                                defaultSelect="Select Prefer Lender"
                                onSelectOption={handleLenderChange}
                                icon="feather-flag"
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-12">
                              <div className="customButton gap-xxl-2 my-xxl-2">
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleClose}
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleReset}
                                >
                                  Reset
                                </button>

                                <button
                                  type="submit"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? "Submitting..." : "Search"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="main-content">
            <div className="row">
              <SettledTable filteredData={filterData} permission={permission} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default SettledList;
